import React from "react";
import TutorailComponent from "./index";
import Box from "@material-ui/core/Box";
import { useStyles } from "../MuiCssStyle/MUiStyle";
const Container = ({ listOfHelper }) => {
  const styles = useStyles();

  return (
    <Box className={styles.recorderWrapper}>
      {listOfHelper.map((value, index) => {
        return <TutorailComponent key={index} {...value} />;
      })}
    </Box>
  );
};

export default Container;
